import { AA_TEST_FR, ALT_SERP_IT, PDP_CSW_POSITION } from './names'
import { ExperimentName } from './types'

/**
 * List of experiments that are manually activated.
 *
 * Add experiment name here if experiment is something like aa test
 */
export const MANUALLY_ACTIVATED: ExperimentName[] = [
  // Experiment has no <Experiment name=... /> part,
  // so it must be enabled manually
  ALT_SERP_IT,
  AA_TEST_FR,
  PDP_CSW_POSITION
]
